export const ENV = process.env.REACT_APP_ENVIROMENT;

export const PaymentProfileConfig = {
    organisationID: process.env.REACT_APP_PAYMENT_ORGANISATION_ID || "",
    gateway: process.env.REACT_APP_PAYMENT_GATEWAY || "",
    apiBase: process.env.REACT_APP_PANUITY_API_BASE || "",
    allowedOrigin: process.env.REACT_APP_PANUITY_ALLOWED_ORIGIN || "",
    iframePath: process.env.REACT_APP_PANUITY_IFRAME_PATH || "",
    environment: process.env.REACT_APP_PANUITY_ENVIRONMENT || "", // Production | Development | Sandbox | Staging
};